import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { AntStyles, StyledDrawer } from './Drawer.styles.js';
import { useDesignSystemThemeName, cleanProps } from '../utils.js';
import { ClearOutline24 } from '../../icons/24/index.js';

var Drawer = function Drawer(props) {
  var children = props.children,
      visible = props.visible,
      className = props.className,
      onClose = props.onClose;
  var themeName = useDesignSystemThemeName();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AntStyles, null), /*#__PURE__*/React__default.createElement(StyledDrawer, _extends({}, cleanProps(props, ['themeName', 'visible', 'onClose']), {
    className: "".concat(className, " ").concat(themeName),
    visible: visible,
    onClose: onClose,
    closeIcon: /*#__PURE__*/React__default.createElement(ClearOutline24, null)
  }), children));
};

Drawer.defaultProps = {
  'data-test-id': 'Drawer'
};

export { Drawer, Drawer as default };
//# sourceMappingURL=Drawer.js.map
